import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Paper)``;

export const TooltipChildWrapper = styled('span')`
  display: flex;
  flex: 1;
`;
